<template>
  <div>TODO: Implement JP Product Page</div>
</template>

<script setup lang="ts"></script>
